import { PriceHistory } from "../interface";
import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";

export const getPriceHistory = async (
  productId: number,
  variantId?: number
): Promise<PriceHistory[]> => {
  try {
    const params: Record<string, string> = {
      productId: productId.toString(),
    };

    if (variantId) {
      params.variantId = variantId.toString();
    }

    return await apiRequest<PriceHistory[]>("get", "/price-history", {
      params,
    });
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch price history");
  }
};
